import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    selectedBranch: null, 
  },
  mutations: {
    setSelectedBranch(state, branchId) {
      state.selectedBranch = branchId; // Actualiza el estado con el nuevo valor
    }
  },
  actions: {
  },
  modules: {
  }
})
